import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { mergeMap } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
import { AuthenticationTokenSet } from '../../models/authentication.model';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {

  const authenticationService = inject(AuthenticationService);

  if (authenticationService.isUrlInAuthorizedUrls(req.url)) {
    return handleRequest(authenticationService, req, next);
  } else {
    return next(req);
  }

}

function handleRequest(authenticationService: AuthenticationService, req: HttpRequest<unknown>, next: HttpHandlerFn) {
  if (authenticationService.tokenNeedsRefreshing()) {
    return authenticationService.refreshAuthentication$().pipe(mergeMap((response: AuthenticationTokenSet) => {
      return cloneRequest(req, next, response?.accessToken);
    }));
  } else {
    return cloneRequest(req, next, authenticationService.getAccessToken());
  }
}

function cloneRequest(req: HttpRequest<unknown>, next: HttpHandlerFn, token: string) {
  const newReq = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  return next(newReq);
}
